import React, { Component } from 'react';
import TSADashboardComponent from '../../components/Dashboard/TSADashboard/TSADashboard';
import { caseAnalyticsTimingDataService, totalGlobalCasesService, totalOutcomeScoreService, getTSAImplantsService, getArmPositionStats } from '../../services/java/java-services';
import { outcomeScoreMessage } from '../../helpers/messages';
import { operativeProcedureTypes } from '../../helpers/constants';
export default class TSADashboardContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			averageCaseTime: '',
			averageTsaCasetime: '',
			totalTimeDataTsa: '',
			totalCasesDetails: '',
			totalTimeData: '',
			totalCasesForAvg: '',
			totalCasesForMax: '',
			totalCasesForMin: '',
			totalGlobalCasesCount: '',
			scoreType: '', // default scoretype
			timeInterval: '', // default timeinterval
			defaultTimeInterval: '6 weeks',
			defaultScoreType: 'ASES',
			scoreTypeParam: 'default',
			selectedSurgeonId: props.surgeonId ? props.surgeonId : '',
			outcomeError: null,
			avgCasetimeError: null,
			globalCaseError: null,
			outcomeLoading: false,
			avgCasetimeLoading: false,
			globalCaseLoading: false,
			initialState: false,
			setuptimePreference: false,
			implantTypeDropdown: [], // tsa arm position
			selectedImplantType: '',
			armPositionError: null,
			armPositionLoading: false,
			armPositionData: null
		}

	}

	componentDidMount() {
		this.getTotalOutcomeScore({ type: 'default' });
		this.getAverageCaseTime({ type: 'avg', daterange: this.props.timeFrameValue });
		this.getTotalGlobalCases({ type: 'avg', daterange: this.props.timeFrameValue });
		this.getTSAImplants()
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.surgeonDetails !== prevProps.surgeonDetails) {
			this.handleSurgeonChange();
		}
		if (this.props.timeFrameValue !== prevProps.timeFrameValue) {
			this.handleTimeFrameChange();
		}
		const { selectedImplantType } = this.state;
		if (
			prevProps.timeFrameValue !== this.props.timeFrameValue ||
			prevState.selectedImplantType !== selectedImplantType
		) {
			this.getTSAArmPositionData();
		}
	}

	/**
	 * @description function to get Average Case Time based on the timeframe input
	 * @param {*}
	 * @memberof TSADashboardContainer
	 */
	getAverageCaseTime = (params) => {
		params['operativeProcedure'] = operativeProcedureTypes.TSA.raw;
		this.setState({ averageCaseTime: '', averageTsaCasetime: '', avgCasetimeError: null, avgCasetimeLoading: true, totalTimeData: '' });

		if (this.props.isRarView && this.props.surgeonDetails) {
			params['surgeonname'] = this.props.surgeonDetails.userName;
		}

		caseAnalyticsTimingDataService(params, (err, res) => {
			if (err) {
				this.setState({ avgCasetimeError: err, avgCasetimeLoading: false });
			} else {
				this.setState({
					avgCasetimeLoading: false,
					averageCaseTime: res.data?.case?.length ? res.data.case.pop() : [],
					averageTsaCasetime: res.data?.casetsa || {},
					totalTimeData: res.data?.totalTimeData || [],
					totalTimeDataTsa: res.data?.totalTimeDataTsa || {},
					setuptimePreference: res.data?.setuptimePreference
				});
			}
		})
	}

	/**
	 * @description function to get  total and global Case count based on the timeframe input
	 * @param {*}
	 * @memberof TSADashboardContainer
	 */
	getTotalGlobalCases = (params) => {
		params['operativeProcedure'] = operativeProcedureTypes.TSA.raw;
		this.setState({ totalGlobalCasesCount: '', globalCaseError: null, globalCaseLoading: true });

		if (this.props.isRarView && this.props.surgeonDetails) {
			params['surgeonname'] = this.props.surgeonDetails.userName;
		}

		totalGlobalCasesService(params, (err, res) => {
			if (err) {
				this.setState({ globalCaseError: err, globalCaseLoading: false });
			} else {
				this.setState({
					globalCaseLoading: false,
					totalGlobalCasesCount: res.data?.case?.length ? res.data.case.pop() : null
				});
			}
		})
	}

	/**
	* @description function to get  total and global Case count in the outcome score
	* @param {*}
	* @memberof TSADashboardContainer
	*/
	getTotalOutcomeScore = (params) => {
		params['operativeProcedure'] = operativeProcedureTypes.TSA.raw;
		this.setState({ totalCasesDetails: '', isLoading: true, outcomeError: null, outcomeLoading: true });

		if (this.props.isRarView && this.props.surgeonDetails) {
			params['surgeonname'] = this.props.surgeonDetails.userName;
		}

		totalOutcomeScoreService(params, (err, res) => {
			if (err) {
				this.setState({ isLoading: false, outcomeError: err, outcomeLoading: false });
			} else {
				const dataSet = res.data?.case?.length ? res.data.case.pop() : null;
				this.setState(prevState => {
					return {
						defaultScoreType: dataSet?.scoreType || prevState.defaultScoreType,
						scoreType: dataSet?.scoreType || prevState.scoreType,
						totalCasesDetails: dataSet,
						isLoading: false,
						outcomeLoading: false
					}
				});
			}
		})
	}

	/**
	* @description Function to handle score type or time interval change for outcome scores quadrant
	* @param e The change event for the select input
	* @param type The score type selected
	* @memberof TSADashboardContainer
	*/
	handleOutcomeScoreValueChange = (e, type) => {
		if (type === 'scoreType') {
			this.setState({ scoreType: e.target.value, scoreTypeParam: e.target.value });
			this.getTotalOutcomeScore({ scoreType: e.target.value });
		}
	}

	/**
	* @description function to get handle change of timeframe
	* @param {*}
	* @memberof TSADashboardContainer
	*/
	handleTimeFrameChange = () => {
		this.getAverageCaseTime({ type: 'avg', daterange: this.props.timeFrameValue });
		this.getTotalGlobalCases({ type: 'avg', daterange: this.props.timeFrameValue });

	}

	/**
	* @description function to get handle change of surgeon selection by RAR
	* @param {*}
	* @memberof TSADashboardContainer
	*/
	handleSurgeonChange = (e) => {
		this.handleTimeFrameChange();
		this.getTotalOutcomeScore({ type: 'default' });
	}

	/**
	 * @description API call to fetch implant types
	 * @memberof TSADashboardContainer
	 */
	getTSAImplants = () => {
		this.setState({ armPositionLoading: true });

		getTSAImplantsService((err, result) => {
			if (err) {
				this.setState({ armPositionLoading: false, armPositionError: err });
			} else {
				const implants = result?.data?.case || [];
				const defaultImplant = implants.length ? implants[0].name : "";

				this.setState({
					implantTypeDropdown: implants,
					selectedImplantType: defaultImplant,
					armPositionLoading: false,
					armPositionError: null,
				});
			}
		});
	};

	/**
	* @description API call to fetch TSA arm position data using selected implant type
	* @memberof TSADashboardContainer
	*/
	getTSAArmPositionData = () => {
		const { selectedImplantType } = this.state;
		const { isRarView, surgeonDetails, timeFrameValue } = this.props;
		this.setState({ armPositionLoading: true });
		let params = {
			daterange: timeFrameValue,
			implantType: selectedImplantType
		}

		if (isRarView && surgeonDetails) {
			params['surgeonname'] = surgeonDetails.userName;
		}

		getArmPositionStats(params, (err, result) => {
			if (err) {
				this.setState({ armPositionError: err, armPositionLoading: false, armPositionData: null });
			} else {
				this.setState({
					armPositionError: null,
					armPositionLoading: false,
					armPositionData: result.data,
				});
			}
		});
	};

	/**
	 * @description function to handle change in implant type dropdown
	 * @memberof TSADashboardContainer
	 */
	handleImplantTypeChange = (e) => {
		this.setState({ selectedImplantType: e.target.value });
	};


	render() {
		const { isRarView, surgeons, surgeonDetails, timeFrameValue } = this.props;
		return (
			<div >
				<TSADashboardComponent
					timeFrameValue={timeFrameValue}
					averageCaseTime={this.state.averageCaseTime}
					averageTsaCasetime={this.state.averageTsaCasetime}
					totalTimeData={this.state.totalTimeData}
					totalTimeDataTsa={this.state.totalTimeDataTsa}
					totalGlobalCasesCount={this.state.totalGlobalCasesCount}
					timeFrameChange={this.handleTimeFrameChange}
					handleOutcomeScoreValueChange={this.handleOutcomeScoreValueChange}
					totalCasesDetails={this.state.totalCasesDetails}
					defaultScoreType={this.state.scoreType ? this.state.scoreType : this.state.defaultScoreType}
					scoreTypeParam={this.state.scoreTypeParam}
					isLoading={this.state.isLoading}
					activeTab={this.state.activeTab}
					handleTabs={this.handleTabs}
					outcomeScoreMessage={outcomeScoreMessage}
					isRarView={isRarView}
					surgeons={surgeons}
					surgeonId={this.state.selectedSurgeonId}
					surgeonDetails={surgeonDetails}
					outcomeError={this.state.outcomeError}
					avgCasetimeError={this.state.avgCasetimeError}
					globalCaseError={this.state.globalCaseError}
					placementError={this.state.placementError}
					outcomeLoading={this.state.outcomeLoading}
					avgCasetimeLoading={this.state.avgCasetimeLoading}
					globalCaseLoading={this.state.globalCaseLoading}
					setuptimePreference={this.state.setuptimePreference}
					implantTypeDropdown={this.state.implantTypeDropdown}
					selectedImplantType={this.state.selectedImplantType}
					armPositionError={this.state.armPositionError}
					armPositionLoading={this.state.armPositionLoading}
					armPositionData={this.state.armPositionData}
					handleImplantTypeChange={this.handleImplantTypeChange}
				/>
			</div>
		);
	}
}
